module.exports = __webpack_public_path__ + "static/media/vsq-logo-white.cf7bbda1.png";